import { render, staticRenderFns } from "./EditPruefungsstueckPage.vue?vue&type=template&id=798dd09b"
import script from "./EditPruefungsstueckPage.vue?vue&type=script&lang=js"
export * from "./EditPruefungsstueckPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports